import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { transactionService } from '../services/api';
import './TransactionPage.css';

const TransactionPage = () => {
  const { arisanId, memberId, type } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    amount: '',
    month: new Date().getMonth() + 1,
    paymentMethod: 'cash',
    referenceNumber: '',
    notes: '',
    round: 1
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = {
        arisanId,
        memberId,
        amount: parseFloat(formData.amount),
        paymentMethod: formData.paymentMethod,
        referenceNumber: formData.referenceNumber,
        notes: formData.notes
      };

      if (type === 'contribution') {
        data.month = parseInt(formData.month);
        await transactionService.recordContribution(data);
      } else {
        data.round = parseInt(formData.round);
        await transactionService.recordDistribution(data);
      }

      navigate(`/arisan/${arisanId}`);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to record transaction');
    } finally {
      setLoading(false);
    }
  };

  const isContribution = type === 'contribution';
  const pageTitle = isContribution ? 'Catat Iuran' : 'Catat Pembagian';

  return (
    <div className="page-container">
      <div className="transaction-container">
        <h2>{pageTitle}</h2>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="transaction-form">
          <div className="form-group">
            <label>Jumlah *</label>
            <div className="amount-input">
              <span className="currency">Rp</span>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
                required
                min="0.01"
                step="0.01"
                placeholder="0.00"
              />
            </div>
          </div>

          {isContribution && (
            <div className="form-group">
              <label>Bulan *</label>
              <select
                name="month"
                value={formData.month}
                onChange={handleChange}
                required
              >
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => (
                  <option key={month} value={month}>
                    Bulan {month}
                  </option>
                ))}
              </select>
            </div>
          )}

          {!isContribution && (
            <div className="form-group">
              <label>Putaran *</label>
              <input
                type="number"
                name="round"
                value={formData.round}
                onChange={handleChange}
                required
                min="1"
              />
            </div>
          )}

          <div className="form-group">
            <label>Metode Pembayaran</label>
            <select
              name="paymentMethod"
              value={formData.paymentMethod}
              onChange={handleChange}
            >
              <option value="cash">Tunai</option>
              <option value="bank_transfer">Transfer Bank</option>
              <option value="online">Pembayaran Online</option>
              <option value="other">Lainnya</option>
            </select>
          </div>

          <div className="form-group">
            <label>Nomor Referensi (Opsional)</label>
            <input
              type="text"
              name="referenceNumber"
              value={formData.referenceNumber}
              onChange={handleChange}
              placeholder="mis., Nomor cek, ID Transfer, dll."
            />
          </div>

          <div className="form-group">
            <label>Catatan (Opsional)</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              rows="3"
              placeholder="Tambahkan catatan tentang transaksi ini"
            ></textarea>
          </div>

          <div className="form-actions">
            <button type="submit" disabled={loading} className="btn-submit">
              {loading ? 'Mencatat...' : 'Catat Transaksi'}
            </button>
            <button
              type="button"
              onClick={() => navigate(`/arisan/${arisanId}`)}
              className="btn-cancel"
            >
              Batal
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TransactionPage;
